import { css } from '@emotion/css'

export const container = css`
  position: relative;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const hiddenInput = css`
  display: none;
`
